export default {
  dataIterator: {
    rowsPerPageText: 'Aantal per pagina:',
    rowsPerPageAll: 'Alles',
    pageText: '{0}-{1} van {2}',
    noResultsText: 'Geen overeenkomende resultaten gevonden',
    nextPage: 'Volgende pagina',
    prevPage: 'Vorige pagina'
  },
  dataTable: {
    rowsPerPageText: 'Rijen per pagina:'
  },
  noDataText: 'Geen gegevens beschikbaar'
}
